import React from 'react';
import { format } from 'date-fns';
import StatusBadge from '../common/StatusBadge';

export function scoreCorrectedTooltip(correctionMode, correctedAt) {
  let dateLabel = null;
  if (correctedAt) {
    const parsed = new Date(correctedAt);
    if (!Number.isNaN(parsed.getTime())) {
      dateLabel = format(parsed, 'MMM d, yyyy');
    }
  }

  if (correctionMode === 'post_session') {
    return dateLabel
      ? `Score corrected after the session ended on ${dateLabel}.`
      : 'Score corrected after the session ended.';
  }

  return dateLabel
    ? `Score corrected during the session on ${dateLabel}.`
    : 'Score corrected during the session.';
}

/**
 * Small “Edited” marker for games whose score was corrected after entry.
 */
const ScoreCorrectedBadge = ({ correctedAt, correctionMode = 'live' }) => {
  const title = scoreCorrectedTooltip(correctionMode, correctedAt);

  return (
    <StatusBadge variant="info" size="small" title={title} className="shrink-0">
      Edited
    </StatusBadge>
  );
};

export default ScoreCorrectedBadge;
